import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
import { useLocation } from 'react-router';
// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', meta, ...other }, ref) => {
  const { pathname } = useLocation();
  const privateOrFormRoute = /^\/(?:auth|dashboard|form|forms|referral|referrals|upload|uploads|account)(?:\/|$)/i.test(pathname)
    || /^\/contact-us\/(?:appointment-request|information-request)(?:\/|$)/i.test(pathname);
  return (
  <>
    <Helmet>
      <title>{`${title} | Stein Counseling & Consulting Services`}</title>
      {meta}
      {privateOrFormRoute && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>

    <Box ref={ref} {...other}>
      {children}
    </Box>
  </>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
